var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { SortableElement } from "react-sortable-hoc";
// interface IRow {}
const DraggableElement = SortableElement(({ children }) => children);
const Row = (_a) => {
    var { key, index, children, totalElement } = _a, rest = __rest(_a, ["key", "index", "children", "totalElement"]);
    // if the children's length is not equal the columns' length, then it's rendering row for frozen table
    if (children.length !== totalElement)
        return (_jsx(DraggableElement, { index: index, children: _jsx("div", Object.assign({}, rest, { children: children })) }, key));
    return _jsx("div", Object.assign({}, rest, { children: children }));
};
export default Row;
